/**
 * VAPID key helpers for the page (src/pwa/subscription.ts, components/social/data.ts). The service worker keeps its
 * own copy of `base64UrlToBytes` in ./push.ts: it is built as a self-contained script and shares no module with the
 * app (test/pwa-push.test.ts checks both agree).
 */

/** base64url → bytes (the VAPID application server key). */
export function base64UrlToBytes(s: string): Uint8Array<ArrayBuffer> {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(s.length / 4) * 4, '=')
  const bin = atob(b64)
  const out = new Uint8Array(new ArrayBuffer(bin.length))
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i)
  return out
}

/** Whether a subscription's `options.applicationServerKey` is this public key (null: the browser does not say). */
export function sameServerKey(applicationServerKey: ArrayBuffer | null | undefined, publicKey: string): boolean | null {
  if (!applicationServerKey) return null
  const a = new Uint8Array(applicationServerKey)
  const b = base64UrlToBytes(publicKey)
  return a.length === b.length && a.every((x, i) => x === b[i])
}
